var jQuery361 = jQuery.noConflict();
window.jQuery = jQuery361;
if (window.location.href.indexOf("form_type=customer") > -1) {
    const nodeList = document.querySelectorAll(".message-error-newsletter");
    for (let i = 0; i < nodeList.length; i++) {
        nodeList[i].style.display = "block";
    }
    // var error_newsletter = document.getElementById('message-error-newsletter');
    // error_newsletter.style.display = 'block';
}
jQuery361(document).ready(function($) {


// let customerEdit = document.getElementById('editar-customer');
//   if (customerEdit != null) {
//     customerEdit.addEventListener('click', (event) => {
//       console.log('se ejecuta');
//     });
//   }


  
 
/** validamos en que pagina nos encontramos **/
  var page_origin ='';
  if (window.location.href.indexOf("login") > -1) {
   page_origin = 'login';
  }else if (window.location.href.indexOf("/register") > -1) {
    page_origin = 'register';
  }  
// seleccionamos los elementos  
  let login = document.querySelector("#customer_login");
  let register = document.querySelector("#RegisterForm");
  let facebookBtn = document.querySelector('.h_facebook_text');
  
//evento de login
  if(login != null){
    login.addEventListener('submit', (event) => {
     setCookie('page_origin', 'login', 1);
    });
  }
//evento de registro
  if(register != null){
    register.addEventListener('submit', (event) => {
       setCookie('page_origin', 'register', 1);
    });
  }
//evento de facebook
  if(facebookBtn != null){
    facebookBtn.addEventListener('click', (event) => {
      console.log('se esta ejecutando el click del boton');
      setCookie('page_origin', page_origin, 1);
      setCookie('metodo_login', 'Facebook', 1);
    });
  }




  
  /**
  ** Slider
  **/
   if(document.querySelector('.slideshow-slide__image-link') != null){
    document.querySelector('.slideshow-slide__image-link').addEventListener('click', function() {
        var arrayElementos = promotion();
        var data_promotion_id = arrayElementos[0];
        var data_promotion_name = arrayElementos[1];
        var data_promotion_image = arrayElementos[2];
        var data_promotion_item_name = arrayElementos[3];
        var data_promotion_index = arrayElementos[4];
        dataLayer.push({
            ecommerce: null
        });
        dataLayer.push({
            'event': 'select_promotion',
            'ecommerce': {
                'items': [{
                    'item_name': data_promotion_item_name,
                    'promotion_id': data_promotion_id,
                    'promotion_name': data_promotion_name,
                    'image': 'https:' + data_promotion_image,
                    'index': data_promotion_index,
                }]
            }
        });
    });

 }
    function promotion() {
        var elemento = $('.swiper-slide-visible');
        var data_promotion_id = $(elemento).attr("data-promotion-id");
        var data_promotion_name = $(elemento).attr("data-promotion-name");
        var data_promotion_image = $(elemento).attr("data-promotion-image");
        var data_promotion_item_name = $(elemento).attr("data-promotion-item-name");
        var data_promotion_index = $(elemento).attr("data-promotion-index");
        var respuesta = [
            data_promotion_id,
            data_promotion_name,
            data_promotion_image,
            data_promotion_item_name,
            data_promotion_index
        ];
        return respuesta;
    }
    for (let index = 1; index < 5; index++) {
        var $div = $("#slider-" + index);
        var x = 1;
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                var attributeValue = $(mutation.target).prop(mutation.attributeName);
                const clase = 'swiper-slide-visible swiper-slide-active';
                if (attributeValue.includes(clase) == true) {
                    if (x == index) {
                        var arrayElementos = promotion();
                        var data_promotion_id = arrayElementos[0];
                        var data_promotion_name = arrayElementos[1];
                        var data_promotion_image = arrayElementos[2];
                        var data_promotion_item_name = arrayElementos[3];
                        var data_promotion_index = arrayElementos[4];
                        x++;
                        dataLayer.push({
                            ecommerce: null
                        });
                        dataLayer.push({
                            'event': 'view_promotion',
                            'ecommerce': {
                                'items': [{
                                    'item_name': data_promotion_item_name,
                                    'promotion_id': data_promotion_id,
                                    'promotion_name': data_promotion_name,
                                    'image': 'https:' + data_promotion_image,
                                    'index': data_promotion_index,
                                }]
                            }
                        });
                    }
                }
            });
        });
     if ($div[0]) {
        observer.observe($div[0], {
            attributes: true,
            attributeFilter: ['class']
        });
     }
       
      
         
       
    }
  /** ---------------------------- **/

  
    /**
    *** funcion para scroll y disparar datalayer collections
    **/
    $(window).scroll(function() {
        var hT = $('#carusel-completa-tu-estilo').offset().top,
            hH = $('#carusel-completa-tu-estilo').outerHeight(),
            wH = $(window).height(),
            scrollPosition = $(this).scrollTop(),
            divPosition = (hT + hH - wH),
            divInicio = divPosition - 10,
            divFinal = divPosition + 10;
        //console.log(divPosition , divInicio, divFinal, scrollPosition);
        if (parseInt(divInicio) < parseInt(scrollPosition) && parseInt(divFinal) > parseInt(scrollPosition)) {
            var elemento = $('.element-collections-estlio');
            var items = [];
            for (var i = 0; i < elemento.length; i++) {
                var data_promotion_id = $(elemento[i]).attr("data-promotion-id");
                var data_promotion_name = $(elemento[i]).attr("data-promotion-name");
                var data_promotion_image = $(elemento[i]).attr("data-promotion-image");
                var data_promotion_item_name = $(elemento[i]).attr("data-promotion-item-name");
                var data_promotion_index = $(elemento[i]).attr("data-promotion-index");
                var newArray = {
                    'item_name': data_promotion_item_name,
                    'promotion_id': data_promotion_id,
                    'promotion_name': data_promotion_name,
                    'image': 'https:' + data_promotion_image,
                    'index': data_promotion_index,
                }
                items.push(newArray);
            }
            //envio del elemento
            dataLayer.push({
                ecommerce: null
            });
            dataLayer.push({
                'event': 'view_promotion',
                'ecommerce': {
                    'items': items
                }
            });
        }
    });
    //scroll function de evento de view promotions productos lo mas vendido
    // $(window).scroll(function() {
    //     var hT = $('#shopify-section-template--15132306538557__1655855558c1ac2348').offset().top,
    //         hH = $('#shopify-section-template--15132306538557__1655855558c1ac2348').outerHeight(),
    //         wH = $(window).height(),
    //         scrollPosition = $(this).scrollTop(),
    //         divPosition = (hT + hH - wH),
    //         divInicio = divPosition - 10,
    //         divFinal = divPosition + 10;
    //     if (parseInt(divInicio) < parseInt(scrollPosition) && parseInt(divFinal) > parseInt(scrollPosition)) {
    //         var elemento = $('.element-collections-productos-Lo-más-trendy');
    //         var items = [];
    //         for (var i = 0; i < elemento.length; i++) {
    //             var data_promotion_id = $(elemento[i]).attr("data-promotion-id");
    //             var data_promotion_name = $(elemento[i]).attr("data-promotion-name");
    //             var data_promotion_image = $(elemento[i]).attr("data-promotion-image");
    //             var data_promotion_item_name = $(elemento[i]).attr("data-promotion-item-name");
    //             var data_promotion_index = $(elemento[i]).attr("data-promotion-index");
    //             var newArray = {
    //                 'item_name': data_promotion_item_name,
    //                 'promotion_id': data_promotion_id,
    //                 'promotion_name': data_promotion_name,
    //                 'image': 'https:' + data_promotion_image,
    //                 'index': data_promotion_index,
    //             }
    //             items.push(newArray);
    //         }
    //         //envio del elemento
    //         dataLayer.push({
    //             ecommerce: null
    //         });
    //         dataLayer.push({
    //             'event': 'view_promotion',
    //             'ecommerce': {
    //                 'items': items
    //             }
    //         });
    //     }
    // });
    //scroll function de evento de view promotions productos Accesorios 
    // $(window).scroll(function() {
    //     var hT = $('#shopify-section-template--15132306538557__166252158070a54e93').offset().top,
    //         hH = $('#shopify-section-template--15132306538557__166252158070a54e93').outerHeight(),
    //         wH = $(window).height(),
    //         scrollPosition = $(this).scrollTop(),
    //         divPosition = (hT + hH - wH),
    //         divInicio = divPosition - 10,
    //         divFinal = divPosition + 10;
    //     if (parseInt(divInicio) < parseInt(scrollPosition) && parseInt(divFinal) > parseInt(scrollPosition)) {
    //         var elemento = $('.element-collections-productos-grid-slider');
    //         var items = [];
    //         for (var i = 0; i < elemento.length; i++) {
    //             var data_promotion_id = $(elemento[i]).attr("data-promotion-id");
    //             var data_promotion_name = $(elemento[i]).attr("data-promotion-name");
    //             var data_promotion_image = $(elemento[i]).attr("data-promotion-image");
    //             var data_promotion_item_name = $(elemento[i]).attr("data-promotion-item-name");
    //             var data_promotion_index = $(elemento[i]).attr("data-promotion-index");
    //             var newArray = {
    //                 'item_name': data_promotion_item_name,
    //                 'promotion_id': data_promotion_id,
    //                 'promotion_name': data_promotion_name,
    //                 'image': 'https:' + data_promotion_image,
    //                 'index': data_promotion_index,
    //             }
    //             items.push(newArray);
    //         }
    //         //envio del elemento
    //         dataLayer.push({
    //             ecommerce: null
    //         });
    //         dataLayer.push({
    //             'event': 'view_promotion',
    //             'ecommerce': {
    //                 'items': items
    //             }
    //         });
    //     }
    // });
    //scroll function de evento de view promotions mocasines
    // $(window).scroll(function() {
    //     var hT = $('#shopify-section-template--15132306538557__1654878022d8e24a9a').offset().top,
    //         hH = $('#shopify-section-template--15132306538557__1654878022d8e24a9a').outerHeight(),
    //         wH = $(window).height(),
    //         scrollPosition = $(this).scrollTop(),
    //         divPosition = (hT + hH - wH),
    //         divInicio = divPosition - 10,
    //         divFinal = divPosition + 10;
    //     if (parseInt(divInicio) < parseInt(scrollPosition) && parseInt(divFinal) > parseInt(scrollPosition)) {
    //         var elemento = $('.lo-mas-nuevo');
    //         var items = [];
    //         for (var i = 0; i < elemento.length; i++) {
    //             var data_promotion_id = $(elemento[i]).attr("data-promotion-id");
    //             var data_promotion_name = $(elemento[i]).attr("data-promotion-name");
    //             var data_promotion_image = $(elemento[i]).attr("data-promotion-image");
    //             var data_promotion_item_name = $(elemento[i]).attr("data-promotion-item-name");
    //             var data_promotion_index = $(elemento[i]).attr("data-promotion-index");
    //             var newArray = {
    //                 'item_name': data_promotion_item_name,
    //                 'promotion_id': data_promotion_id,
    //                 'promotion_name': data_promotion_name,
    //                 'image': 'https:' + data_promotion_image,
    //                 'index': data_promotion_index,
    //             }
    //             items.push(newArray);
    //         }
    //         //envio del elemento
    //         dataLayer.push({
    //             ecommerce: null
    //         });
    //         dataLayer.push({
    //             'event': 'view_promotion',
    //             'ecommerce': {
    //                 'items': items
    //             }
    //         });
    //     }
    // });
    /** ---------------------------- **/  
  
  $("#cart-cfdi").change(function() {
        var cfdi = $("#cart-cfdi option:selected").val();
        CartJS.setAttribute("CFDI", cfdi);
        console.log(cfdi);
    });

  
    let submitBtn = document.querySelector("#submit-btn");
    if (submitBtn != null) {
        submitBtn.addEventListener("click", (event) => {
            $("#tracking-info-detail").hide();
            event.preventDefault();
            let number = document.getElementById("number").value;
            const api_url = "https://ninewest.engranedigital.com/facturacion/api/tracking/" + number;
            fetch(api_url).then((response) => response.text()).then((response) => {
                console.log(response);
                return JSON.parse(response);
            }).then(function(data) {
                if (data == "") {
                    $("#tracking-info-detail").hide();
                    appendErrorBtn();
                } else {
                    document.getElementById("submit-btn").value = "";
                    appendDataBtn(data);
                }
            }).catch(function(err) {
                appendErrorBtn();
                console.log("error: " + err);
            });
        });
    }


  let rastrearBtn = document.querySelector("#rastrear_pedido");
  let tracking_order = document.querySelector(".tracking_order");

  if (rastrearBtn != null && tracking_order != null) {
        rastrearBtn.addEventListener("click", (event) => {
          $("#tracking-info-detail").hide();
            tracking_order.style.display = "block";
            event.preventDefault();
            let number = rastrearBtn.dataset.ordernum;
            const api_url = "https://ninewest.engranedigital.com/facturacion/api/tracking/" + number;
            fetch(api_url).then((response) => response.text()).then((response) => {
                console.log(response);
                return JSON.parse(response);
            }).then(function(data) {
                if (data == "") {
                    $("#tracking-info-detail").hide();
                    appendErrorBtn();
                } else {
                    // document.getElementById("submit-btn").value = "";
                    appendDataBtn(data);
                }
            }).catch(function(err) {
                appendErrorBtn();
                console.log("error: " + err);
            });
        });
    }



  $("#sendFormData23").on('submit', function (e) {
              Swal.fire({
                  title: 'ESPERA!',
                  html: 'Estamos registrando tus datos!',// add html attribute if you want or remove
                  allowOutsideClick: false,
                  showConfirmButton: false,
                  onBeforeOpen: () => {
                      Swal.showLoading()
                  },
              });
              var name = $("#Nombre").val();
              var lastname = $("#Apellido").val();
              var email = $("#Email").val();
              e.preventDefault();
            
  
              url = 'https://ninewest.engranedigital.com/newsletter/sf.php';
              var posting = {
                  email: email,
                  name: name,
                  lastname: lastname,
              };
             fetch(url, {
              method: 'POST',
              headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json'
              },
              body: JSON.stringify({'data': posting})
            }).then(function(data){
               return data.json();
            }).then(myJson => { 
               Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: myJson.msg,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false,
                  timer: 2000
              }).then((data) => {
                  location.reload();
                 // console.log('listo')
              });
            });
  
              
          });
  




   $("#sendFormDataCamapana").on('submit', function (e) {
        Swal.fire({
            title: 'ESPERA!',
            html: 'Estamos registrando tus datos!',// add html attribute if you want or remove
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
                Swal.showLoading()
            },
        });
        var name = $("#Nombre").val();
        var lastname = $("#Apellido").val();
        var email = $("#Email").val();
        e.preventDefault();
      
        url = 'https://ninewest.engranedigital.com/newsletter/sf_camapana.php';
        var posting = {
            email: email,
            name: name,
            lastname: lastname,
        };
       fetch(url, {
        method: 'POST',
        headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
        },
        body: JSON.stringify({'data': posting})
      }).then(function(data){
         return data.json();
      }).then(myJson => { 
         Swal.fire({
            position: 'center',
            icon: 'success',
            title: myJson.msg,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            timer: 2000
        }).then((data) => {
            location.reload();
           // console.log('listo')
        });
      });

        
    });


  
  
});

// // funcion para envio al hacer click en lo mas vendido onclick
function event_lomasvendido(nombre) {
    var elemento = $('.element-collections-productos-' + nombre);
    var items = [];
    for (var i = 0; i < elemento.length; i++) {
        var data_promotion_id = $(elemento[i]).attr("data-promotion-id");
        var data_promotion_name = $(elemento[i]).attr("data-promotion-name");
        var data_promotion_image = $(elemento[i]).attr("data-promotion-image");
        var data_promotion_item_name = $(elemento[i]).attr("data-promotion-item-name");
        var data_promotion_index = $(elemento[i]).attr("data-promotion-index");
        var newArray = {
            'item_name': data_promotion_item_name,
            'promotion_id': data_promotion_id,
            'promotion_name': data_promotion_name,
            'image': 'https:' + data_promotion_image,
            'index': data_promotion_index,
        }
        items.push(newArray);
    }
    //envio del elemento
    dataLayer.push({
        ecommerce: null
    });
    dataLayer.push({
        'event': 'view_promotion',
        'ecommerce': {
            'items': items
        }
    });
}


// select promotions collections onclick
function selectPromotion(data_promotion_item_name, data_promotion_name, data_promotion_id, data_promotion_index, data_promotion_image, url) {
    var items = [];
    var newArray = {
        'item_name': data_promotion_item_name,
        'promotion_id': data_promotion_id,
        'promotion_name': data_promotion_name,
        'image': 'https:' + data_promotion_image,
        'index': data_promotion_index,
    }
    items.push(newArray);
    //envio del elemento
    dataLayer.push({
        ecommerce: null
    });
    dataLayer.push({
        'event': 'select_promotion',
        'ecommerce': {
            'items': items
        }
    });
   window.location.href = url;
}

// select promotions promotion items onclick whit select items
function selectPromotionProduct(
    data_promotion_item_name,
     data_promotion_name, 
     data_promotion_id, 
     data_promotion_index, 
     data_promotion_image, 
     url,
  
     product_id,
    variant_id = null
     ) {
    var items = [];
    var newArray = {
        'item_name': data_promotion_item_name,
        'promotion_id': data_promotion_id,
        'promotion_name': data_promotion_name,
        'image': 'https:' + data_promotion_image,
        'index': data_promotion_index,
    }
    items.push(newArray);
    //envio del elemento
    dataLayer.push({
        ecommerce: null
    });
    dataLayer.push({
        'event': 'select_promotion',
        'ecommerce': {
            'items': items
        }
    });
    productInformations(product_id, url, variant_id);
}

// select item en promociones y productos
function productInformations(product_id, url, variant_id = null) {
      var productoId = product_id;
    var urlProduct = url;
    var variantId = variant_id;
        jQuery.getJSON("/cart.js", function(cart) {
            const options = {
                method: "GET",
            };
            fetch("https://ninewest.engranedigital.com/products/index.php?prod=" + productoId + "&variant_id=" +variantId, options)
              .then((response) => response.text())
              .then((data) => {
                const item = JSON.parse(data);
                var coloMaterial = (item.color) ? item.color + " - " + item.material : '';
                var size = (item.size) ? item.size : '';
                console.log(item);
                dataLayer.push({
                    ecommerce: null,
                });
                dataLayer.push({
                    event: "select_item",
                    ecommerce: {
                        cart_id: cart.token,
                        date_created__cart: today,
                        date_update__cart: today,
                        total_quantity_cart: cart.item_count + 1,
                        total_price_cart: priceFormat(cart.total_price),
                        items: [{
                            item_name: item.title,
                            item_id: item.id,
                            price: item.price,
                            price_without_discount: item.compare_at_price,
                            discount: item.discount,
                            item_brand: item.brand,
                            item_category: item.product_type,
                            item_category2: "",
                            silueta: "",
                            tacon: "",
                            item_variant: coloMaterial,
                            size: size,
                            is_in_stock: "Yes",
                            image: item.image,
                            quantity: 1,
                            index: "",
                            currency: "MXN",
                            type: item.type,
                            is_on_sale: item.is_on_sale,
                            added_date: today,
                        }],
                    },
                });
            });

        });
       window.location.href = urlProduct;
      // window.open(urlProduct, "_blank");
      
}

// let btn_cart_checkout = document.querySelector("button[name='checkout']");
// var msg_rfc = document.querySelector("#msg_rfc");
// var msg_rfc_val = document.querySelector("#msg_rfc_val");
// let rfc_input = document.querySelector("#rfc");
// let facturacionCheckbox = document.querySelector("#facturacion");
// let privacidad = document.querySelector("#Privacidad");
// let cfdi_input = document.querySelector("#cart-cfdi");
// let uso_input = document.querySelector("#cart-uso");
// btn_cart_checkout.addEventListener("click", () => {
//     if(btn_cart_checkout.type == "button"){
//       // window.alert("El campo RFC es requerido");
//    msg_rfc.style.display = "block";
//     }
// });
// var cfdi = '';
// var uso = '';
//   if (cfdi_input != null && uso_input != null) {
//     cfdi_input.disabled = true;
// uso_input.disabled = true;
//   }

// jQuery361("#Privacidad").change(function(){
//       if( jQuery(this).is(':checked') ){
//          btn_cart_checkout.disabled = false;
//       }else{
//         btn_cart_checkout.disabled = true;
//       }
//  });
// jQuery361("#facturacion").change(function(){
//       if( jQuery(this).is(':checked') ){
//          privacidad.disabled = true;
//       }else{
//         privacidad.disabled = false;
//       }
//  });
// if (rfc_input != null) {
//     rfc_input.addEventListener("keyup", () => {
//         if (rfc_input.value != "") {
//             msg_rfc.style.display = "none";
//             msg_rfc_val.style.display = "block";
//             let RFC = validateRfc(rfc.value);
//             console.log(RFC.isValid);
//             if (RFC.isValid == true) {
//                 console.log("aca paso");
//                 // btn_cart_checkout.disabled = false;
//                 msg_rfc_val.style.display = "none";
//                 CartJS.setAttribute("RFC", rfc.value);
//               cfdi_input.disabled = false;
//             } else {
//                 console.log("aca no paso");
//                 btn_cart_checkout.disabled = true;
//                 msg_rfc_val.style.display = "block";
//             }
//         } else {
//             btn_cart_checkout.disabled = true;
//             msg_rfc.style.display = "block";
//             msg_rfc_val.style.display = "none";
//         }
//     });
// }

// jQuery361("#cart-cfdi").change(function () {
//   cfdi = jQuery361("#cart-cfdi option:selected").val();
//     if (cfdi !=  '') {
//       uso_input.disabled = false;
//     }else{
//       // btn_cart_checkout.disabled = true;  
//      uso_input.disabled = true;
//     }
//   console.log(cfdi)
// });
// jQuery361("#cart-uso").change(function () {
//   uso = jQuery361("#cart-uso option:selected").val();
//   console.log(uso)
//     if (uso !=  '') {
//     privacidad.disabled = false;
//   }else{
//       privacidad.disabled = true;
//   }
// });

function appendDataBtn(data) {
    let tab = "";
    tab += `<form id="caja-guia">`;
    for (let guia of data) {
        tab += `<div class="guia-box">`;
        tab += `<input type="radio"  onclick="getGuia('${guia.guia_id}','${guia.carrier}')" id="${guia.guia_id}" name="guia_id" value="${guia.guia_id}" >`;
        // tab += `<input type="radio" onclick="alert('I am an alert box!');" id="${guia.guia_id}" name="guia_id" value="${guia.guia_id}" >`;
        tab += `<label for="${guia.guia_id}">`;
        tab += `<h2>${guia.guia_id}</h2>`;
        tab += `<p>Paqueteria: ${guia.carrier}</p>`;
        // tab += `<p>${guia.item}</p>`;
        tab += `<p><b>Ver Detalle</b></p>`;
        tab += `</label></div>`;
        // tab += `<button onclick="getGuia(${guia.guia_id})" class="btn btn-success" class="btn-guia">${guia.guia_id} - ${guia.item}</button>`;
        document.getElementById("guias-btn").innerHTML = tab;
    }
    tab += `</form>`;
}

function appendErrorBtn() {
    jQuery361("#tracking-info-detail").hide();
    let tab = "";
    tab += '<div class="alert alert-warning">Estamos procesando tu pedido, en breve te mostraremos más información.</div>';
    document.getElementById("guias-btn").innerHTML = tab;
}

function appendDataPExpss(data) {
    jQuery361("#tracking-info-detail").show();
    var generada = "dispatch";
    var fecha_generada = "";
    var procesando = "dispatch";
    var fecha_procesando = "";
    var transito = "dispatch";
    var fecha_transito = "";
    var entregado = "dispatch";
    var fecha_entregado = "";
    let tab = "";
    for (let r of data) {
        if (r.eventoId == "SWB") {
            generada = "confirm";
            fecha_generada = r.fecha;
        } else if (r.eventoId == "TRN" || r.eventoId == "WHU" || r.eventoId == "HTC" || r.eventoId == "HLP" || r.eventoId == "TTM") {
            transito = "process";
            fecha_transito = r.fecha;
        } else if (r.eventoId == "HDC" || r.eventoId == "BDL") {
            entregado = "delivery";
            fecha_entregado = r.fecha;
        } else if (r.eventoId == "CDT" || r.eventoId == "HCM" || r.eventoId == "HDR" || r.eventoId == "HBD" || r.eventoId == "FDG" || r.eventoId == "HCA") {
            procesando = "process";
            fecha_procesando = r.fecha;
        }
    }
    tab += `<div class="confirm">
                                        <div class="imgcircle">
                                            <i class="fas fa-shopping-cart"></i>
                                        </div>
                                        <span class="line"></span>
                                        <p class="status-title">Pedido Confirmado</p>
                                        <p class="status-date">${fecha_generada}</p>
                                    </div>`;
    tab += `<div class="${procesando}">
                                        <div class="imgcircle">
                                            <i class="fas fa-box"></i>
                                        </div>
                                        <span class="line"></span>
                                        <p class="status-title">Preparando tu pedido</p>
                                        <p class="status-date">${fecha_procesando}</p>
                                    </div>`;
    tab += `<div class="${transito}">
                                        <div class="imgcircle">
                                            <i class="fas fa-truck"></i>
                                        </div>
                                        <span class="line"></span>
                                        <p class="status-title">Pedido en camino</p>
                                        <p class="status-date">${fecha_transito}</p>
                                    </div>`;
    tab += `<div class="${entregado}">
                                        <div class="imgcircle">
                                            <i class="fas fa-people-carry"></i>
                                        </div>
                                        <p class="status-title">Entregado</p>
                                        <p class="status-date">${fecha_entregado}</p>
                                    </div>`;
    document.getElementById("tracking-info-detail").innerHTML = tab;
}

function appendDataAMPM(data) {
    jQuery361("#tracking-info-detail").show();
    var generada = "dispatch";
    var fecha_generada = "";
    var procesando = "dispatch";
    var fecha_procesando = "";
    var transito = "dispatch";
    var fecha_transito = "";
    var entregado = "dispatch";
    var fecha_entregado = "";
    let tab = "";
    for (let r of data) {
        if (r.codigo == "ER") {
            generada = "confirm";
            fecha_generada = r.fecha;
        } else if (r.codigo == "CV" || r.codigo == "CM") {
            transito = "process";
            fecha_transito = r.fecha;
        } else if (r.codigo == "EN") {
            entregado = "delivery";
            fecha_entregado = r.fecha;
        } else if (r.codigo == "DR" || r.codigo == "DR" || r.codigo == "CV" || r.codigo == "SI" || r.codigo == "LI" || r.codigo == "LE" || r.codigo == "VI") {
            procesando = "process";
            fecha_procesando = r.fecha;
        }
    }
    tab += `<div class="confirm">
                                        <div class="imgcircle">
                                            <i class="fas fa-shopping-cart"></i>
                                        </div>
                                        <span class="line"></span>
                                        <p class="status-title">Pedido Confirmado</p>
                                        <p class="status-date">${fecha_generada}</p>
                                    </div>`;
    tab += `<div class="${procesando}">
                                        <div class="imgcircle">
                                            <i class="fas fa-box"></i>
                                        </div>
                                        <span class="line"></span>
                                        <p class="status-title">Preparando tu pedido</p>
                                        <p class="status-date">${fecha_procesando}</p>
                                    </div>`;
    tab += `<div class="${transito}">
                                        <div class="imgcircle">
                                            <i class="fas fa-truck"></i>
                                        </div>
                                        <span class="line"></span>
                                        <p class="status-title">Pedido en camino</p>
                                        <p class="status-date">${fecha_transito}</p>
                                    </div>`;
    tab += `<div class="${entregado}">
                                        <div class="imgcircle">
                                            <i class="fas fa-people-carry"></i>
                                        </div>
                                        <p class="status-title">Entregado</p>
                                        <p class="status-date">${fecha_entregado}</p>
                                    </div>`;
    document.getElementById("tracking-info-detail").innerHTML = tab;
}

function appendError() {
    jQuery361("#tracking-info-detail").show();
    let tab = "";
    tab += '<div class="alert alert-warning">No ha sido posible encontrar información con este número de guía, te pedimos verificarlo o por favor contacta con atención al <a href="https://sperry.com.mx/pages/contactanos" style="text-decoration: underline;font-weight:800">cliente</a></div>';
    document.getElementById("tracking-info-detail").innerHTML = tab;
}

function isconfirmed() {
    jQuery361("#tracking-info-detail").show();
    var generada = "dispatch";
    var fecha_generada = "";
    var procesando = "dispatch";
    var fecha_procesando = "";
    var transito = "dispatch";
    var fecha_transito = "";
    var entregado = "dispatch";
    var fecha_entregado = "";
    let tab = "";
    tab += `<div class="confirm">
                                        <div class="imgcircle">
                                            <i class="fas fa-shopping-cart"></i>
                                        </div>
                                        <span class="line"></span>
                                        <p class="status-title">Pedido Confirmado</p>
                                        <p class="status-date">${fecha_generada}</p>
                                    </div>`;
    tab += `<div class="${procesando}">
                                        <div class="imgcircle">
                                            <i class="fas fa-box"></i>
                                        </div>
                                        <span class="line"></span>
                                        <p class="status-title">Preparando tu pedido</p>
                                        <p class="status-date">${fecha_procesando}</p>
                                    </div>`;
    tab += `<div class="${transito}">
                                        <div class="imgcircle">
                                            <i class="fas fa-truck"></i>
                                        </div>
                                        <span class="line"></span>
                                        <p class="status-title">Pedido en camino</p>
                                        <p class="status-date">${fecha_transito}</p>
                                    </div>`;
    tab += `<div class="${entregado}">
                                        <div class="imgcircle">
                                            <i class="fas fa-people-carry"></i>
                                        </div>
                                        <p class="status-title">Entregado</p>
                                        <p class="status-date">${fecha_entregado}</p>
                                    </div>`;
    document.getElementById("tracking-info-detail").innerHTML = tab;
}

function getGuia(id, carrier) {
  let submitBtn = document.querySelector("#submit-btn");
    var id_guia = id.toString();
    var carrier = carrier;
    if (carrier == "paqueteexpress" || carrier == "PAQUETEXPRESS" || carrier == "Paquete Express") {
        const api_url = "https://cc.paquetexpress.com.mx/ptxws/rest/api/v1/guia/historico/" + id_guia + "/@1@2@3@4@5?source=WEBPAGE";
        fetch(api_url).then((response) => response.text()).then((response) => {
            let json = response.replace("Resultado(", "");
            let respuesta = json.replace(")", "");
            return JSON.parse(respuesta);
        }).then(function(data) {
            if (data == "") {
                appendError();
            } else {
              appendDataPExpss(data);
              if (submitBtn != null) {
                submitBtn.value = "";
              }
               
                
            }
        }).catch(function(err) {
            appendError();
            //                     console.log('error: ' + err);
        });
    } else if (carrier == "AMPM") {
        const api_url = "https://ninewest.engranedigital.com/guias/ampm.php?num=" + id_guia;
        fetch(api_url).then((response) => response.text()).then((response) => {
            return JSON.parse(response);
        }).then(function(data) {
            if (data == "No encontrada") {
                appendError();
            } else {
              if (submitBtn != null) {
                submitBtn.value = "";
              }
                if (data == null) {
                    isconfirmed();
                } else {
                    appendDataAMPM(data);
                }
            }
        }).catch(function(err) {
            appendError();
            //                     console.log('error: ' + err);
        });
    } else if (carrier == "estafeta" || carrier == "ESTAFETA") {
        jQuery361("#tracking-info-detail").show();
        var track = id_guia;
        var ifram = `<iframe src="https://cs.estafeta.com/es/Tracking/searchByGet?wayBill=${track}&wayBillType=0&isShipmentDetail=True" width="100%" height="1024" scrolling="no" style="overflow: hidden; height: 1249px;"></iframe>`;
        document.getElementById("tracking-info-detail").innerHTML = ifram;
    } else if (carrier == "TIENDA") {
         if (submitBtn != null) {
                submitBtn.value = "";
              }
        appendDataStore();
    } else {
        console.log("error");
    }
}

function appendDataStore() {
    jQuery361("#tracking-info-detail").show();
    let store = `<div style="text-align:center" class="cyc-message">
                        <img src="https://cdn.shopify.com/s/files/1/0578/6373/3309/files/compras.png?v=1666134794" class="img-cyc">
                        <h3>Ya puedes retirar tu pedido en tienda.</h3>
                      </div>`;
    document.getElementById("tracking-info-detail").innerHTML = store;
}

function addToCartModalProduct(product_id) {
    // setTimeout(() => {
    jQuery361("#boost-pfs-quickview-cart-form").submit(function(event) {
       event.preventDefault();
        var formObj = {};
        var inputs = jQuery361(this).serializeArray();
        formObj["product_id"] = product_id;
        jQuery361.each(inputs, function(i, input) {
            formObj[input.name] = input.value;
        });
        jQuery.getJSON("/cart.js", function(cart) {
            // console.log(cart)
            addToCart(cart, formObj);
        });
        console.log(formObj);
      view_cart('view_cart');
        return formObj;
       
      
    });
  
    // }, 5000)
}

function addToCartNoModalProduct(product_id, variant_id) {
   var variantID = variant_id;
    var formObj = {};
   var cartID = '';
  var userID = getCookie('gtm_rdg_user_id');
  if (userID == '' || userID == null) {
    cartID = getCookie('cart');
  }
    jQuery.getJSON("/cart.js", function(cart) {
        setTimeout(() => {
            const options = {
                method: "GET",
            };
            fetch("https://ninewest.engranedigital.com/products/index.php?prod=" + product_id + "&variant_id=" + variant_id, options).then((response) => response.text()).then((data) => {
                const item = JSON.parse(data);
                dataLayer.push({
                    ecommerce: null,
                });
                dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                        cart_id: cart.token,
                        date_created__cart: today,
                        date_update__cart: today,
                        total_quantity_cart: cart.item_count + 1,
                        total_price_cart: priceFormat(cart.total_price),
                        items: [{
                            item_name: item.title,
                            item_id: item.id,
                            price: item.price,
                            price_without_discount: item.compare_at_price,
                            discount: item.discount,
                            item_brand: item.brand,
                            item_category: item.product_type,
                            item_category2: "",
                            silueta: "",
                            tacon: "",
                            item_variant: item.color + " - " + item.material,
                            size: item.size,
                            is_in_stock: "Yes",
                            image: item.image,
                            quantity: 1,
                            index: "",
                            currency: "MXN",
                            type: item.type,
                            is_on_sale: item.is_on_sale,
                            added_date: today,
                        }],
                    },
                });
               // datalayer ASistente virtual
                  dataLayer.push({
                    'cloud_retail': {
                      'eventType': 'add-to-cart',
                      'visitorId': cartID,
                      // You can also define the visitor ID
                      // directly on the Tag Manager tag.
                      'cartId': cart.token,
                      'productDetails': [{
                        'product': {
                          'id': item.id
                        },
                        'quantity': variant.quantity
                      }]
                    }
                  });
                  /***** ****/
                // console.log(ecommerce)
            });
          
          view_cart('view_cart');
        }, 3000);
    });
    event.preventDefault();
    return true;
}

function addToCart(cart, variant) {
    var cartID = '';
  var userID = getCookie('gtm_rdg_user_id');
  if (userID == '' || userID == null) {
    cartID = getCookie('cart');
  }
    const options = {
        method: "GET",
    };
    fetch("https://ninewest.engranedigital.com/products/index.php?prod=" + variant.product_id, options).then((response) => response.text()).then((data) => {
        const item = JSON.parse(data);
        console.log(item);
        dataLayer.push({
            ecommerce: null,
        });
        dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                cart_id: cart.token,
                date_created__cart: today,
                date_update__cart: today,
                total_quantity_cart: cart.item_count + 1,
                total_price_cart: priceFormat(cart.total_price),
                items: [{
                    item_name: item.title,
                    item_id: item.id,
                    price: item.price,
                    price_without_discount: item.compare_at_price,
                    discount: item.discount,
                    item_brand: item.brand,
                    item_category: item.product_type,
                    item_category2: "",
                    silueta: "",
                    tacon: "",
                    item_variant: variant.option1 + " - " + variant.option3,
                    size: variant.option2,
                    is_in_stock: "Yes",
                    image: item.image,
                    quantity: variant.quantity,
                    index: "",
                    currency: "MXN",
                    type: item.type,
                    is_on_sale: item.is_on_sale,
                    added_date: today,
                }],
            },
        });
      // datalayer ASistente virtual
          dataLayer.push({
            'cloud_retail': {
              'eventType': 'add-to-cart',
              'visitorId': cartID,
              // You can also define the visitor ID
              // directly on the Tag Manager tag.
              'cartId': cart.token,
              'productDetails': [{
                'product': {
                  'id': item.id
                },
                'quantity': variant.quantity
              }]
            }
          });
          /****** *******/
    });
}

function removeOrAddItemCart(type, idProduct, size, color, material, quantity) {
  setTimeout(() => {
    jQuery.getJSON('/cart.js', function(cart) {
       const options = {
          method: "GET"
      };
  
      fetch("https://ninewest.engranedigital.com/products/index.php?prod=" + idProduct, options)
          .then(response => response.text())
          .then(data => {
              const item = JSON.parse(data);
              // console.log(item)
              dataLayer.push({
                  ecommerce: null
              });
              dataLayer.push({
                event: type,
                ecommerce: {
                      'cart_id': cart.token,
                      'date_created__cart': today,
                      'date_update__cart': today,
                      'total_quantity_cart': cart.item_count,
                      'total_price_cart': priceFormat(cart.total_price),
                      'items': [{
                          'item_name': item.title,
                          'item_id': item.id,
                          'price': item.price,
                          'price_without_discount': item.compare_at_price,
                          'discount': item.discount,
                          'item_brand': item.brand,
                          'item_category': item.product_type,
                          'item_category2': '',
                          'silueta': '',
                          'tacon': '',
                          'item_variant': color + ' - ' + material,
                          'size': size,
                          'is_in_stock': 'Yes',
                          'image': item.image,
                          'quantity': quantity,
                          'index': '',
                          'currency': 'MXN',
                          'type': item.type,
                          'is_on_sale': item.is_on_sale,
                          'added_date': today,
                      }]
                  }
              });
          });
        });
  }, 500)
}

function removeItemCart(product_id, variant_id) {
    var productoID = product_id;
    var variantID = variant_id;
    jQuery.getJSON('/cart.js', function(cart) {
        setTimeout(() => {
            const options = {
                method: "GET"
            };

            fetch("https://ninewest.engranedigital.com/products/index.php?prod=" + product_id + "&variant_id=" + variant_id, options)
                .then(response => response.text())
                .then(data => {
                    const item = JSON.parse(data);
                    dataLayer.push({
                        ecommerce: null
                    });
                    dataLayer.push({
                        event: "remove_from_cart",
                        ecommerce: {
                            'cart_id': cart.token,
                            'date_created__cart': today,
                            'date_update__cart': today,
                            'total_quantity_cart': cart.item_count,
                            'total_price_cart': priceFormat(cart.total_price),
                            'items': [{
                                'item_name': item.title,
                                'item_id': item.id,
                                'price': item.price,
                                'price_without_discount': item.compare_at_price,
                                'discount': item.discount,
                                'item_brand': item.brand,
                                'item_category': item.product_type,
                                'item_category2': '',
                                'silueta': '',
                                'tacon': '',
                                'item_variant': item.color + ' - ' + item.material,
                                'size': item.size,
                                'is_in_stock': 'Yes',
                                'image': item.image,
                                'quantity': 1,
                                'index': '',
                                'currency': 'MXN',
                                'type': item.type,
                                'is_on_sale': item.is_on_sale,
                                'added_date': today,
                            }]
                        }
                    });
                    // console.log(ecommerce)
                });
        }, 500);
    });
    event.preventDefault();
    return true;
}

function view_cart(tipo) {
  setTimeout(function() {
     jQuery.getJSON('/cart.js', function(cart) {
        const options = {
            method: "POST",
            body: JSON.stringify(cart),
            headers: {
            'Content-Type': 'application/json'
          },
        };
       fetch("https://ninewest.engranedigital.com/products/cart.php?items=1", options)
        .then(response => response.text())
        .then(data => {
            const items = JSON.parse(data);
            // alert('se esta ejecutando la funcion beging_checkout');
            dataLayer.push({
                ecommerce: null
            });
            dataLayer.push({
                event: tipo,
                ecommerce: {
                    'cart_id': cart.token,
                    'date_created__cart': today,
                    'date_update__cart': today,
                    'total_quantity_cart': cart.item_count,
                    'total_price_cart': priceFormat(cart.total_price),
                    'items': items
                }
            });
        });
      });
  }, 1000);
     
}

function view_item(producto, variant) {
  
   jQuery.getJSON('/cart.js', function(cart) {
        // setTimeout(() => {
            const options = {
                method: "GET"
            };

            fetch("https://ninewest.engranedigital.com/products/index.php?prod=" + producto + "&variant_id=" + variant, options)
                .then(response => response.text())
                .then(data => {
                    const item = JSON.parse(data);
                    dataLayer.push({
                        ecommerce: null
                    });
                    dataLayer.push({
                        event: "view_item",
                        ecommerce: {
                            'cart_id': cart.token,
                            'date_created__cart': today,
                            'date_update__cart': today,
                            'total_quantity_cart': cart.item_count,
                            'total_price_cart': priceFormat(cart.total_price),
                            'items': [{
                                'item_name': item.title,
                                'item_id': item.id,
                                'price': item.price,
                                'price_without_discount': item.compare_at_price,
                                'discount': item.discount,
                                'item_brand': item.brand,
                                'item_category': item.product_type,
                                'item_category2': '',
                                'silueta': '',
                                'tacon': '',
                                'item_variant': item.color + ' - ' + item.material,
                                'size': item.size,
                                'is_in_stock': 'Yes',
                                'image': item.image,
                                'quantity': 1,
                                'index': '',
                                'currency': 'MXN',
                                'type': item.type,
                                'is_on_sale': item.is_on_sale,
                                'added_date': today,
                            }]
                        }
                    });
                  /*** datalayer asistente virtual **/
                //   dataLayer.push({
                //   'cloud_retail': {
                //     'eventType': 'detail-page-view',
                //     'visitorId': cartid,
                //     'productDetails': [{
                //       'product': {
                //         'id': item.id
                //       }
                //     }]
                //   }
                // });
                  /********* ***/
                    // console.log(ecommerce)
                });
        // }, 3000);
    });
}


function priceFormat(params) {
    var price = parseFloat(params) / 100;
    return price.toFixed(2);
}

/** set cookie **/
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
   d.setTime(d.getTime() + (exdays * 60 * 1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return false;
}


/*-------------------------------------------
  01. actualizar customer
--------------------------------------------- */
  let customerEdit = document.getElementById('editar-customer');
  if (customerEdit != null) {
    customerEdit.addEventListener('click', (event) => {
      event.preventDefault();
        Swal.fire({
                    title: 'Actualizar datos de cliente',
                    html:
                    `<label for="swal2-input" class="swal2-input-label">Nombre</label>
                    <input id="swal-input1" class="swal2-input">`+
                    `<label for="swal2-input" class="swal2-input-label">Apellido</label>
                    <input id="swal-input2" class="swal2-input">`,
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    showLoaderOnConfirm: true,
                    focusConfirm: false,
                    preConfirm: () => {
                        return new Promise(function (resolve, reject) {
                          let nombre = document.getElementById("swal-input1").value;
          let apellido = document.getElementById("swal-input2").value;
                            if (nombre == '' || apellido == '') {
                                Swal.disableButtons();	 // Enable the confirm button again.
                                Swal.hideLoading()	
                                swal.showValidationMessage("Ingrese valores validos"); // Show error when validation fails.
                            } else {
                                swal.resetValidationMessage(); // Reset the validation message.
                                resolve(updateCustomer(customerEdit.dataset.id,nombre,apellido));
                            }
                        })
                    },
                    allowOutsideClick: () => Swal.isLoading()
                }).then((result) => {
                    if (result.isConfirmed) {
                        console.log(result)
                        Swal.fire({
                            icon: `${result.value.icon}`,
                            title: `${result.value.msg}`,
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((result) => {
                            // Reload the Page
                            location.reload();
                        });
                    }
                })
    });
  }
  
function updateCustomer(customer, first_name, last_name)
{
    let data = {
        id: customer,
        first_name: first_name,
        last_name: last_name
    };
    return fetch('https://ninewest.engranedigital.com/facturacion/api/customer/updated', {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(data)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(response.statusText)

        }
        return response.json()
    })
    .catch(error => {
        Swal.showValidationMessage(
            `Request failed: ${error}`
        )
    })
}
 
// const drawerButton = document.querySelector('[data-js-menu-button]');
// const menuSuperior = document.getElementById('menu-superior');

// drawerButton.addEventListener('click', () => {
//   menuSuperior.classList.toggle('oculto');
// });


if (typeof drawerButton === 'undefined') {
  const drawerButton = document.querySelector('[data-js-menu-button]');
  const menuSuperior = document.getElementById('menu-superior');

  drawerButton.addEventListener('click', () => {
    menuSuperior.classList.toggle('oculto');
  });
}
